import { Stack, Skeleton, Typography } from "@mui/material";
export const FieldsLoader = () => {
  return <Stack gap={3} data-sentry-element="Stack" data-sentry-component="FieldsLoader" data-sentry-source-file="FieldsLoader.tsx">
      <FieldSkeleton size="small" data-sentry-element="FieldSkeleton" data-sentry-source-file="FieldsLoader.tsx" />
      <FieldSkeleton size="large" data-sentry-element="FieldSkeleton" data-sentry-source-file="FieldsLoader.tsx" />
      <FieldSkeleton size="small" data-sentry-element="FieldSkeleton" data-sentry-source-file="FieldsLoader.tsx" />
      <FieldSkeleton size="small" data-sentry-element="FieldSkeleton" data-sentry-source-file="FieldsLoader.tsx" />
      <FieldSkeleton size="large" data-sentry-element="FieldSkeleton" data-sentry-source-file="FieldsLoader.tsx" />
      <FieldSkeleton size="small" data-sentry-element="FieldSkeleton" data-sentry-source-file="FieldsLoader.tsx" />
    </Stack>;
};
type FieldSkeletonProps = {
  size: "small" | "large";
};
const FieldSkeleton = ({
  size
}: FieldSkeletonProps) => {
  return <Stack gap={0.5} data-sentry-element="Stack" data-sentry-component="FieldSkeleton" data-sentry-source-file="FieldsLoader.tsx">
      <Stack direction="row" justifyContent="space-between" data-sentry-element="Stack" data-sentry-source-file="FieldsLoader.tsx">
        <Typography variant="h5" data-sentry-element="Typography" data-sentry-source-file="FieldsLoader.tsx">
          <Skeleton variant="text" width={192} data-sentry-element="Skeleton" data-sentry-source-file="FieldsLoader.tsx" />
        </Typography>
        <Skeleton variant="circular" width={20} height={20} data-sentry-element="Skeleton" data-sentry-source-file="FieldsLoader.tsx" />
      </Stack>
      <Skeleton variant="rounded" width="100%" height={size === "large" ? 120 : 40} data-sentry-element="Skeleton" data-sentry-source-file="FieldsLoader.tsx" />
    </Stack>;
};